import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { theme } from '../../theme';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
    ChartDataLabels,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

function aggregateData(data: any, keyVal: string) {
    const chartValues = [];

    for (const key in data) {
        if (data.hasOwnProperty(key)) {
            chartValues.push(data[key][keyVal]);
        }
    }

    return chartValues;
}

function VerticalBarChart({parentToChild}: any) {
    
    const {mode, talkTrackData} = parentToChild;

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top' as const,
            },
            title: {
                display: false,
            },
            datalabels: {
                display: false,
                color: mode === 'light' ? 'black' : 'white',
                labels: {
                    value: {
                        color: mode === 'light' ? 'black' : 'white',
                    },
                },
            },
        },
        scales: {
            x: {
                title: {
                    display: false,
                    text: 'Interaction Type',
                    color: mode === 'light' ? '#797979' : '#b3b3b3',
                },
                ticks: {
                    color: mode === 'light' ? '#797979' : '#b3b3b3',
                },
                grid: {
                    color: mode === 'light' ? '#e4e4e4' : '#5e5e5e',
                },
                // min: 1,
                // max: 10,
            },
            y: {
                title: {
                    display: false,
                    text: 'Ratio (%)',
                    color: mode === 'light' ? '#797979' : '#b3b3b3',
                },
                ticks: {
                    color: mode === 'light' ? '#797979' : '#b3b3b3',
                },
                grid: {
                    color: mode === 'light' ? '#e4e4e4' : '#5e5e5e',
                },
            },
        },
    };
      
    const labels = ['Wallet Sizing', 'Card Usage', 'Alternative Payment', 'Vendor/Merchants', 'Competitor'];
      
    const data = {
        labels,
        datasets: [
            {
                label: 'Agent',
                data: talkTrackData ? aggregateData(talkTrackData, 'agent_avg') : 0,
                backgroundColor: theme.colors.primary,
                color: mode === 'light' ? 'black' : 'white',
            },
            {
                label: 'Top Decile Peer',
                data: talkTrackData ? aggregateData(talkTrackData, 'top_decile_peer') : 0,
                backgroundColor: mode === 'light' ? '#747480' : '#747480',
            },
            {
                label: 'Bottom Decile Peer',
                data: talkTrackData ? aggregateData(talkTrackData, 'bottom_decile_peer') : 0,
                backgroundColor: mode === 'light' ? '#b7ad6c' : '#b7ad6c',
            },
        ],
    };

    return <Bar options={options} data={data} />;
}

export default VerticalBarChart;